<template>
  <div class="wishlist">
    <div class="wl-header">
      <img :src="wishlist.logo" class="wl-header-logo">
      <h2 class="wl-title">{{wishlist.name}}</h2>
      <p class="wl-subtitle" v-if="wishlist.link"><a :href="wishlist.link"  target="_blank"> Klikk her for å se gaveliste hos {{wishlist.name}} </a></p>
    </div>
    <div class="wl-body">
      <table style="width: 100%;"  :border="isMobile ? 0 : 0">
        <tr>
          <th></th>
          <th>Varenavn</th> 
          <th v-if="!isMobile || (!wishlist.showBought && isMobile)">Ønsket</th>
          <th v-if="wishlist.showBought && !isMobile">Kjøpt</th>
          <th v-if="wishlist.showBought && isMobile">Kjøpt/<br>Ønsket</th>
          <th style="padding-left: 10px;">Pris{{!isMobile ? '/stk' : ''}}</th>
        </tr>
        <tr v-for="(gift, idx) in visibleGifts" :key="idx">
          <td><img :src="gift.img" class="wl-row-image"></td>
          <td><a :href="gift.link" target="_blank" style="color: black;">{{gift.name}}</a></td> 
          <td v-if="!isMobile || (!wishlist.showBought && isMobile)">{{gift.want}} stk</td>
          <td v-if="wishlist.showBought && !isMobile">{{gift.bought}} stk<plus-minus @plus="updateGift(wishlistIdx, idx, 1)" @minus="updateGift(wishlistIdx, idx, -1)" style="float: right;"/></td> 
          <td v-if="wishlist.showBought && isMobile"><plus-minus @plus="updateGift(wishlistIdx, idx, 1)" @minus="updateGift(wishlistIdx, idx, -1)" style="float: left;"/>{{gift.bought}}&nbsp;/&nbsp;{{gift.want}}</td> 
          <td style="padding-left: 10px;">{{gift.price}},-</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    wishlist: {
      type: Object,
      required: true
    },
    wishlistIdx: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  computed: {
    windowWidth() {
      return window.innerWidth
    },
    isMobile() {
      return this.windowWidth <= 900
    },
    visibleGifts() {
      return this.wishlist.gifts.filter(gift => {
        if(this.wishlist.showBought) return true 
        else return gift.want > gift.bought
      })
    },
  },
  methods: {
    ...mapActions([ 'updateGiftBought', ]),
    updateGift: function(wishListIdx, giftIdx, change) {
      let oldNum = this.wishlist.gifts[giftIdx].bought
      let newNum = oldNum + change
      this.updateGiftBought({wishListIdx, giftIdx, newNum})
      
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss">
  .wishlist {
    width: 95%;
    margin: 20px auto 70px;
  }

  .wl-header {
    height: 100px;
    width: 100%;
    background: white;
    text-align: left;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 100px 1fr;
    grid-template-areas:  
      'img  title'
      'img  subtitle';
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.65);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.65);
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.65);
  }

  .wl-header-logo {
    width: 100%;
    height: auto;
    grid-area: img;
  }

  .wl-title {
    color: black;
    grid-area: title;
    text-align: left;
    padding-top: 8px;
    font-size: 36px;
  }

  .wl-subtitle {
    color: black;
    grid-area: subtitle;
    text-align: left;
    @media screen and (max-width: 900px){
      font-size: calc(0.7em + 1.5vw);
    }
  }

  .wl-body {
    width: 98%;
    background: white;
    height: 100px;
    margin: auto;
    padding: 20px 0px;
    display: table;

    //also inner shadow to fix shadow from above element.
    -webkit-box-shadow: inset 0px 14px 10px -12px rgba(0,0,0,0.65), 0px 6px 10px 0px rgba(0,0,0,0.65);;
    -moz-box-shadow: inset 0px 14px 10px -12px rgba(0,0,0,0.65), 0px 6px 10px 0px rgba(0,0,0,0.65);
    box-shadow: inset 0px 14px 10px -12px rgba(0,0,0,0.65), 0px 6px 10px 0px rgba(0,0,0,0.65);

    & > table {
      padding: 14px;
      & th, td {
        @media screen and (max-width: 900px){
          padding: 4px;
          white-space: nowrap;
          & > a {
            white-space: initial;
            word-wrap: break-word;
          }
        }
      }
    }
  }

  table, th, td {
    text-align: left;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }


  .wl-row-image {
    height: 40px;
    width: auto;
    max-width: 50px;
  }

  
</style>
